"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollupFieldLogic = void 0;
const fields_logic_registry_1 = require("../../field-type-registry/fields-logic-registry");
const comparisons_1 = require("../../comparisons/comparisons");
const fields_1 = require("../../utils/fields");
const intl_1 = require("../../locale/intl");
const rollup_fieldtype_1 = require("../../safe-field-value/calculated-fields/rollup-field/rollup.fieldtype");
const texts_1 = require("../../texts");
const linked_record_1 = require("../../utils/linked-record");
const target_field_1 = require("../../utils/target-field");
const view_control_rules_1 = require("../../utils/view-control-rules");
const base_number_fieldtype_1 = require("../base-fields/base-number.fieldtype");
class RollupFieldLogic extends base_number_fieldtype_1.BaseNumberFieldLogic {
    constructor() {
        super(...arguments);
        this.name = "rollupfield";
        this.label = (0, intl_1.$t)(texts_1.rollupFieldText.rollup);
        this.icon = "rollup";
        this.iconColor = "#0055DB";
        this.isCalculated = true;
        this.uneditableFieldError = (0, intl_1.$t)(texts_1.rollupFieldText.a_linked_ecord_field_is_required);
        this.fieldValueGetter = new rollup_fieldtype_1.RollupFieldValueGetter();
    }
    get validators() {
        return {};
    }
    isValueEmpty(fieldValue) {
        return fieldValue === null || fieldValue === undefined;
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            editOnStartTyping: false,
            switchToInputControl: "OnCellSelect",
            editorWidth: "100%",
            allowAddRecordToGroup: false,
        };
    }
    getViewControlRules(field) {
        if (!field.params.target_field_structure) {
            return (0, view_control_rules_1.getInvalidFieldViewControlRules)();
        }
        return super.getViewControlRules(field);
    }
    hasUneditableFieldError(field, application) {
        return !(0, linked_record_1.hasLinkedFields)(application);
    }
    getComparisons(field, rule) {
        return (0, target_field_1.withTargetField)(field, comparisons_1.stubTrueComparisons, (targetField, targetFieldType) => {
            return targetFieldType.getComparisons(targetField, rule);
        });
    }
    getFilterComponentData(field, comparison) {
        return (0, target_field_1.withTargetField)(field, {}, (targetField, targetFieldType) => {
            return {
                placeholder: targetFieldType.placeholder,
                ...targetFieldType.getFilterComponentData(targetField, comparison),
            };
        });
    }
    processFilterValue(filterValue, comparison, field, userPreferences) {
        return (0, target_field_1.withTargetField)(field, this.fieldValueGetter.getEmptyValue(), (targetField, fieldType) => fieldType.processFilterValue(filterValue, comparison, targetField, userPreferences));
    }
    valueToString(fieldValue, field, userPreferences, record) {
        return (0, target_field_1.withTargetField)(field, "", (targetField, fieldType) => fieldType.valueToString(fieldValue, targetField, userPreferences, record));
    }
    valueToExcelExport(fieldValue, field, userPreferences, _record) {
        if (fieldValue && !isNaN(Number(fieldValue))) {
            return {
                t: "n",
                v: String(fieldValue),
            };
        }
        return {
            t: "t",
            v: this.valueToExport(fieldValue, field, userPreferences, _record),
        };
    }
    getAggregateDisplayValue(fieldValue, field, userPreferences, record) {
        return (0, target_field_1.withTargetField)(field, "", (targetField, fieldType) => fieldType.getAggregateDisplayValue(fieldValue, targetField, userPreferences, record));
    }
    searchKey(fieldValue, field, userPreferences) {
        return (0, target_field_1.withTargetField)(field, "", (targetField, fieldType) => fieldType.searchKey(fieldValue, targetField, userPreferences));
    }
    showSystemLockIcon() {
        return true;
    }
    getCommonFieldParams(field) {
        var _a, _b;
        return {
            ...(_b = (_a = field.params) === null || _a === void 0 ? void 0 : _a.target_field_structure) === null || _b === void 0 ? void 0 : _b.params,
            ...super.getCommonFieldParams(field),
            system: false,
            primary: false,
        };
    }
    getGridColumnSettings(field) {
        return {
            ...super.getGridColumnSettings(field),
            contentAlignment: "right",
        };
    }
    canChangeValue() {
        return false;
    }
    getInitialParams(field, structure) {
        const linkedField = (0, linked_record_1.getDefaultLinkedFieldSlug)(field, structure);
        return {
            linked_field: linkedField,
        };
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 90,
            minWidth: 45,
        };
    }
    canHaveReferencedRecords() {
        return true;
    }
    /**
     * Get referenced records from both linked and target fields.
     */
    getReferencedRecords(fieldValue, field, record, structure) {
        var _a;
        if (!fieldValue) {
            return [];
        }
        const linkedField = (0, fields_1.getAppFieldBySlug)(structure, (_a = field.params.linked_field) !== null && _a !== void 0 ? _a : "");
        if (!linkedField) {
            return [];
        }
        const linkedFieldLogic = (0, fields_logic_registry_1.getFieldLogic)(linkedField.field_type);
        const linkedFieldValue = (0, fields_1.getValueFromRecordByField)(record, linkedField);
        return linkedFieldLogic.getReferencedRecords(linkedFieldValue, linkedField, record, structure);
    }
    prepareFieldDataToClipboard(field) {
        const defaultData = super.prepareFieldDataToClipboard(field);
        return (0, target_field_1.withTargetField)(field, defaultData, (targetField, targetFieldLogic) => targetFieldLogic.prepareFieldDataToClipboard(targetField));
    }
    isSupportedByBulkAction() {
        return false;
    }
    progressWidgetGoalValueToString(fieldValue, field, userPreferences) {
        return (0, target_field_1.withTargetField)(field, "0", (targetField, targetFieldLogic) => targetFieldLogic.progressWidgetGoalValueToString(fieldValue, targetField, userPreferences));
    }
    metricWidgetValueToString(fieldValue, field, userPreferences) {
        return (0, target_field_1.withTargetField)(field, "0", (targetField, targetFieldLogic) => targetFieldLogic.metricWidgetValueToString(fieldValue, targetField, userPreferences));
    }
}
exports.RollupFieldLogic = RollupFieldLogic;
